import axios from '../../../axios';
import ISaveOnBoardingAnswer from '../types/ISaveOnBoardingAnswer';

const url = 'recruitersearch/api/onboarding';

export const getActiveQuestions = () => axios.get(`${url}/getActiveQuestions`);
export const saveUserInput = (data: ISaveOnBoardingAnswer) =>
  axios.post(`${url}/saveUserInput`, data);
